import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类别快速筛选你感兴趣的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {displayCategories.map((cat, index) => {
            const isAccent = index === 0 || index === 1;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl border transition-all duration-300 cursor-pointer ${
                  isAccent
                    ? 'bg-accent-50 border-accent-200 hover:border-accent-400 hover:bg-accent-100'
                    : 'bg-background-50 border-background-200/70 hover:border-primary-200 hover:bg-background-100'
                }`}
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center transition-transform duration-300 group-hover:scale-110 ${
                    isAccent ? 'bg-accent-500 text-background-50' : 'bg-primary-100 text-primary-600'
                  }`}
                >
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {cat.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}